module.exports = __webpack_public_path__ + "static/img/maestrologo.8d51cc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardlogos/maestrologo.png
// module id = pN7/
// module chunks = 1